<div class="flex flex-col gap-4">
  <app-src-settings-activation></app-src-settings-activation>

  <app-src-room-control-mode></app-src-room-control-mode>

  <app-src-settings-algorithms></app-src-settings-algorithms>
</div>
